import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { map, Observable } from 'rxjs';
import { checkLogin } from './auth.helper';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  /**
   * Creates an instance of service.
   * 
   * @param msalService MSAL service.
   * @param msalBroadcastService MSAL event broker service.
   * @param router Application router.
   */
  constructor(
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private router: Router) { }

  /**
   * CanActivate interface implementation.
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.checkLogin();
  }

  /**
   * CanActivateChild interface implementation.
   */
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.checkLogin();
  }

  /**
   * CanLoad interface implementation.
   */
  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> {
    return this.checkLogin();
  }

  /**
   * Checks if current user is already logged in.
   * 
   * @returns True when user is logged in, otherwise - redirect URL.
   */
  private checkLogin(): Observable<boolean | UrlTree> {
    return checkLogin(this.msalService, this.msalBroadcastService).pipe(
      map(result => result || this.router.parseUrl(''))
    );
  }
}
